/* eslint eqeqeq: "off" */
import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Flex,
  Image,
  ConfigProvider,
  Divider,
  Typography,
  Form,
  Input,
  Avatar,
  Tooltip,
} from "antd";
import Timer from "otp-timer";
import { SafetyCertificateOutlined, UserOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";
import TinyColor from "@ctrl/tinycolor";
//components
import "./auth.css";
import Logo from "../../assets/images/logo-main.png";
// import Logo from "../../assets/images/sidebar-logo.png";
import arrow from "../../assets/images/arrow-1.png";
import { emailIsValid, phoneIsValid } from "./validations";
import SimpleReactValidator from "simple-react-validator";
import { isEmpty } from "lodash";
import api, { setAuthToken } from "../../helpers";
import { useHistory } from "react-router";
import { toast, ToastContainer } from "react-toastify";
import { MetaTags } from "react-meta-tags";

const { Title } = Typography;

const Login = (props) => {
  const [form] = Form.useForm();
  const history = useHistory();
  //State maintenance
  const [otpValue, setOtpValue] = useState("");
  const [locationPosition, setLocationPosition] = useState({
    latitude: "",
    longitude: "",
  });
  // const [getOtp, setGetOtp] = useState(false);
  const [error, setError] = useState("");
  const [userValue, setUserValue] = useState("");
  const [loader, setLoader] = useState(false);
  const [otpLoader, setOtpLoader] = useState(false);
  const [userId, setUserId] = useState("");

  //validations
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState();

  //location finding
  useEffect(() => {
    navigator.geolocation.getCurrentPosition(function (position) {
      setLocationPosition({
        ...locationPosition,
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      });
    });
    if (navigator.geolocation) {
      navigator.permissions
        .query({ name: "geolocation" })
        .then(function (result) {});
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Login functionality
  const [otpButtonDisabled, setOtpButtonDisabled] = useState(false);
  const [signInButtonDisabled, setSignInButtonDisabled] = useState(false);

  const otpValidations = () => {
    if (simpleValidator.current.allValid()) {
      setOtpButtonDisabled(true);
      setTimeout(() => {
        setOtpButtonDisabled(false);
      }, 4000);

      setOtpLoader(true);
      const user = {
        mobileNo: userValue,
        // otp: otpValue,
      };
      api
        .post("/auth/users/login", user)
        .then((res) => {
          setGetOtp(true);
          setError("");
          setUserId(res.data.userId);

          setTimeout(() => {
            setOtpLoader(false);
          }, 2000);
          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            (error && error.message) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message);
          setError(errorMsg);
          setGetOtp(false);
          setOtpLoader(true);
          setTimeout(() => {
            setOtpLoader(false);
          }, 2000);
          Promise.reject(error);
        });
      // history.push("/user-details");
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    }
  };

  const signIn = () => {
    if (simpleValidator.current.allValid()) {
      setSignInButtonDisabled(true);
      setTimeout(() => {
        setSignInButtonDisabled(false);
      }, 4000);
      const user = {
        userId: userId,
        // "otp": "228100",
        latitude: locationPosition.latitude,
        longitude: locationPosition.longitude,
        // email: userValue,
        otp: otpValue,
      };
      api
        .post("/auth/users/otpverification", user)
        .then((res) => {
          setAuthToken(res.data.token);
          toast.success("User Logged in successfully");
          localStorage.setItem("authToken", res.data.token);
          localStorage.setItem("welcomeNotification", true);
          history.push({ pathname: "/dashboard", state: res.data });
          localStorage.setItem("authData", JSON.stringify(res.data));
          setError("");
          setLoader(true);
          setTimeout(() => {
            setLoader(false);
          }, 2000);
          return res.data;
        })
        .catch((error) => {
          console.log(error, "error");
          const errorMsg =
            (error && error.message) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message);
          setError(errorMsg);
          setLoader(true);
          setTimeout(() => {
            setLoader(false);
          }, 2000);
          Promise.reject(error);
        });
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    }
  };

  //Onchange
  const onChange = (text) => {
    setOtpValue(text);
  };
  const sharedProps = {
    onChange,
  };

  const validationChange = ({ target: { value: inputValue } }) => {
    const mainInput = document.getElementById("main-input");
    const current_value = inputValue.replace(/ /g, "");
    setUserValue(current_value);

    if (!phoneIsValid(current_value) && !emailIsValid(current_value)) {
      document.getElementById("error-panel").style.display = "block";
      mainInput.value = current_value;
    } else {
      document.getElementById("error-panel").style.display = "none";
      if (phoneIsValid(current_value)) {
        const phoneNumberArr = [...current_value.matchAll(/\d{2}/g)].map(
          (x) => x["0"]
        );
        mainInput.value = phoneNumberArr.join(" ");
        // setuserValue(true);
      }
    }
  };
  const [getOtp, setGetOtp] = useState(false);

  //otp condition false
  const otpInputRef = useRef(null);
  useEffect(() => {
    if (getOtp === true) {
      setTimeout(() => {
        setGetOtp(false);
      }, 45000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getOtp]);

  useEffect(() => {
    if (getOtp === true && userValue) {
      setTimeout(() => {
        otpInputRef.current?.focus(); // Ensure focus on the OTP input field
      }, 100);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getOtp, userValue]);

  //button styles
  const getHoverColors = (colors) =>
    colors.map((color) => new TinyColor(color).lighten(5).toString());
  const getActiveColors = (colors) =>
    colors.map((color) => new TinyColor(color).darken(5).toString());

  const colors1 = ["#6253E1", "#04BEFE"];

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Login | Mbook</title>
        </MetaTags>
      </div>
      <div className="p-2 login-main-card-details">
        <div className="login-main-card">
          <div className={"login-content"}>
            <div
              className={userValue && getOtp ? "login-otp-main" : "login-main"}
            >
              <Form
                form={form}
                name="register"
                // onFinish={onFinish}

                initialValues={{
                  prefix: "91",
                }}
                className="register-form"
                // style={{
                //   maxWidth: 800,
                // }}
                scrollToFirstError
              >
                <div className="flex justify-center">
                  <Image src={Logo} preview={false} width={150} />
                </div>
                <Typography className="mt-4 mb-1 text-[red] text-[13px] text-center">
                  {!isEmpty(error) && error.error ? error.error : ""}
                </Typography>
                <Form.Item name="userValue" className="mt-8 mb-3">
                  <Input
                    className="p-2"
                    id="main-input"
                    name="userValue"
                    value={userValue}
                    style={{
                      fontFamily: "Poppins",
                    }}
                    placeholder="Enter your Mobile or Email"
                    onChange={validationChange}
                  />
                  <p className="text-start text-[red] mt-2 mb-3">
                    {simpleValidator.current.message(
                      "Email or mobile",
                      userValue,
                      "required"
                    )}
                  </p>
                </Form.Item>
                <div
                  id="error-panel"
                  style={{
                    display: "none",
                    marginTop: "-15px",
                    marginBottom: "10px",
                  }}
                >
                  {isEmpty(userValue) ? (
                    ""
                  ) : (
                    <p className="text-start text-[#ff0000]">
                      The email or mobile field is not valid
                    </p>
                  )}
                </div>
                {/* <Typography className="text-start">Mobile Number</Typography>
          <Form.Item
            name="phone"
            rules={[
              {
                required: true,
                message: "Enter a valid phone number",
              },
            ]}
          >
            <Input addonBefore={prefixSelector} className="w-[150%] p-1" />
          </Form.Item> */}
                <div className="w-[100%]">
                  <Button
                    type="dashed"
                    disabled={
                      !userValue || otpButtonDisabled
                        ? true
                        : (userValue && getOtp) || isEmpty(error)
                        ? false
                        : false
                    }
                    className="auth-login-label"
                    onClick={() => otpValidations()}
                  >
                    {otpLoader ? "Loading..." : "Get OTP"}
                  </Button>
                </div>
                {getOtp && userValue ? (
                  <>
                    <Flex
                      gap="middle"
                      align="flex-start"
                      style={{
                        marginTop: "10px",
                        marginBottom: "20px",
                        marginLeft: "10px",
                      }}
                      vertical
                    >
                      <Title
                        style={{
                          marginBottom: "-5px",
                        }}
                        level={6}
                      ></Title>
                      <Input.OTP
                        ref={otpInputRef}
                        formatter={(str) => str.toUpperCase()}
                        {...sharedProps}
                      />
                    </Flex>{" "}
                  </>
                ) : (
                  ""
                )}
                {getOtp && userValue ? (
                  <div className="mt-2">
                    <Timer
                      textColor={"#ff4d4f"}
                      seconds={45}
                      minutes={0}
                      // buttonColor={'red'}
                      background={"none"}
                      // text={`OTP sent to you via sms or e-mail`}
                      text={`Entered OTP sent to you mobile or email - `}
                      // resend={handleClick}
                    />
                  </div>
                ) : (
                  ""
                )}
                {getOtp && userValue ? (
                  <p
                    className="cursor-pointer text-[black] text-[14px] underline"
                    onClick={() => otpValidations()}
                  >
                    Resend OTP
                  </p>
                ) : (
                  ""
                )}

                <ConfigProvider
                  theme={{
                    components: {
                      Button: {
                        colorPrimary: `linear-gradient(116deg,  ${colors1.join(
                          ", "
                        )})`,
                        colorPrimaryHover: `linear-gradient(116deg, ${getHoverColors(
                          colors1
                        ).join(", ")})`,
                        colorPrimaryActive: `linear-gradient(116deg, ${getActiveColors(
                          colors1
                        ).join(", ")})`,
                        lineWidth: 0,
                      },
                    },
                  }}
                >
                  <Button
                    type="primary"
                    className={
                      getOtp && userValue
                        ? "mt-[50px] p-5 w-[100%] auth-login-label"
                        : "pointer-events-none opacity-25 mt-[50px] p-5 w-[100%] auth-login-label"
                    }
                    disabled={signInButtonDisabled ? true : false}
                    htmlType="submit"
                    onClick={signIn}
                  >
                    {loader ? "Loading..." : "Login"}
                  </Button>
                </ConfigProvider>
                <Divider style={{ fontWeight: 600, marginTop: "20px" }}>
                  {" "}
                  <SafetyCertificateOutlined /> 100% secure
                </Divider>
                <div className="flex justify-center mt-[40px] w-[100%]">
                  {/* <h1
                    // type="dashed"
                    className="w-[60%] cursor-pointer p-3 text-[blue] hover:none underline"
                    onClick={() => history.push("/employee-login")}
                  >
                    Employee Login
                  </h1> */}
                  <Button
                    type="dashed"
                    className="w-[50%] p-3 hover:none auth-login-label"
                    onClick={() => history.push("/employee-login")}
                  >
                    Employee Login
                  </Button>
                </div>
              </Form>
            </div>
          </div>
          <div className="login-image">
            <div className="login-image-content">
              <h1 className="login-image-content-text text-start leading-none font-[700]">
                Welcome to <br /> our community
              </h1>
              <p className="font-poppins text-[18px] text-start leading-tight text-[lightgray] mt-3">
                Personalised, update daily and beautifully presented. <br />{" "}
                Create account to find your dream new home and get full <br />{" "}
                access to platform's functionality.
              </p>
            </div>
            <div className="flex">
              <Avatar.Group className="avatar-card">
                <Avatar src="https://api.dicebear.com/7.x/miniavs/svg?seed=1" />
                <a href="https://ant.design">
                  <Avatar
                    style={{
                      backgroundColor: "#f56a00",
                    }}
                  >
                    K
                  </Avatar>
                </a>
                <Tooltip title="User" placement="top">
                  <Avatar
                    style={{
                      backgroundColor: "#87d068",
                    }}
                    icon={<UserOutlined />}
                  />
                </Tooltip>
                <Avatar
                  style={{
                    backgroundColor: "#1677ff",
                  }}
                  icon={<UserOutlined />}
                />
              </Avatar.Group>
              <p className="ml-[10px] mt-3 text-[14px] text-[lightgray]">
                4k+ customers joined with us, now it's your turn
              </p>
            </div>

            <div className="image-arrow">
              <Image
                src={arrow}
                preview={false}
                width={230}
                color="white"
                className="text-[black]"
              />
            </div>
          </div>
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        style={{
          fontSize: "12px",
        }}
        pauseOnHover
        theme="dark"
      />
    </React.Fragment>
  );
};

Login.propTypes = {
  onRegister: PropTypes.any,
};

export default Login;
